import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import DriversApi from './api'
import { ApiParams } from '../../types'

interface UseDriversViewProps extends ApiParams {}

const useDriversView = ({ filters }: UseDriversViewProps) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.DRIVERS_ADMIN, filters],
    () => DriversApi.getDrivers({ filters }),
    {
      staleTime: Infinity,
    },
  )

  return {
    drivers: data,
    isLoading,
  }
}

export default useDriversView
